import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { bootstrapDemo } from './demo';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');
const root = ReactDOM.createRoot(rootElement);

// Install the demo fetch shim (and load fixtures in replay mode) before the app
// mounts and starts making requests. No-op unless VITE_DEMO_MODE is set.
void bootstrapDemo().then(() => {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
